var map = {
	"./appstore.png": 82790,
	"./blog.png": 10082,
	"./facebook.png": 20502,
	"./instagram.png": 59556,
	"./linkedin.png": 89408,
	"./playstore.png": 2901,
	"./twitter.png": 77945,
	"./website.png": 6475,
	"./whatsapp.png": 58644,
	"./youtube.png": 60371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16385;